/* @flow */
/* eslint react/no-danger:0 */

import React from 'react';
import { slide as Menu } from 'react-burger-menu';

type BurgerMenuProps = {
    content: string,
};

const BurgerMenu = ({ content }: BurgerMenuProps) => (
    <Menu
        pageWrapId={'burger-content'}
        outerContainerId={'burger-container'}
        customBurgerIcon={
            <div>
                <i className="icon icon-icon-dk_menu" /> <span>menu</span>
            </div>
        }
        customCrossIcon={
            <div>
                <i className="icon icon-icon-dk_close" />
            </div>
        }
    >
        <div dangerouslySetInnerHTML={{ __html: content }} />
    </Menu>
);

export default BurgerMenu;



// WEBPACK FOOTER //
// ./resources/assets/admin/global/js/components/BurgerMenu.js